module.exports = __webpack_public_path__ + "img/icons-banner.0b22d60e.svg";